import {
    SET_CLIENTS,
    SET_DETAIL_CLIENT,
    SET_DIALOG_ACTIVE,
} from '@/views/clients/store/types/types.js';

const mutations = {
    [SET_CLIENTS]: (state, payload) => state.clients = payload,
    [SET_DETAIL_CLIENT]: (state, detailClient) => state.detailClient = detailClient,
    [SET_DIALOG_ACTIVE]: (state, { status, index }) => state.clients[index]['activeDialogClient'] = status,

};

export default mutations